import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";
export default store => ({
  path: "*",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(
          /* webpackChunkName: "admin-settings-v2" */ "SchoolSetup/routes/AttendanceSetup/modules/Module"
        ),
        import(/* webpackChunkName: "admin-settings-v2" */ "./components"),
      ]).then(([importedModule0, importedModule1]) => {
        const attendanceSetupModule = importedModule0;
        const component = importedModule1.default;
        const attendanceSetupReducer = attendanceSetupModule.default;
        const attendanceSetupReducerKey = attendanceSetupModule.NAME;
        injectReducer(store, {
          key: attendanceSetupReducerKey,
          reducer: attendanceSetupReducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
});
